module.exports = __webpack_public_path__ + "media/images/mouse-91805d4a66bd2ea49ce8bf6ccfff8ea4.svg";